module.exports = __webpack_public_path__ + "img/sc_logo_full.748b3815.svg";